import * as React from "react";
import {Fragment} from "react";
import ReminderNotification from "../../../model/notification/reminder/ReminderNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: ReminderNotification
}

/**
 * Note notification toast body.
 */
const NotificationNoteToastBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Note reminder</div>
			<div className={"toast-body"}>
				{props.notification.data.content}
			</div>
		</Fragment>
	);
};

export default NotificationNoteToastBody;